import { useEffect, useRef } from 'react';

const AdsterraBanner = () => {
  const adRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      atOptions = {
        'key' : '4d5646e1dbc8d3c0194bc83afe066031',
        'format' : 'iframe',
        'height' : 90,
        'width' : 728,
        'params' : {}
      };
    `;
    const script2 = document.createElement("script");
    script2.src = "//www.highperformanceformat.com/4d5646e1dbc8d3c0194bc83afe066031/invoke.js";
    script2.type = "text/javascript";

    if (adRef.current) {
      adRef.current.appendChild(script);
      adRef.current.appendChild(script2);
    }
  }, []);

  return <div ref={adRef} style={{ width: '728px', height: '90px' }} className="my-4 flex justify-center items-center" />;
};

export default AdsterraBanner;
